import { useEffect, useState } from 'react';
import { useCUTranslate } from '../../CUTranslation/hook/useCUTranslate';
import { useControlUnitById } from '../../controlUnit/hooks/useControlUnitById';
import { useAppDispatch, useAppSelector } from '../../store.model';
import { fetchCUParameters } from '../action/thunks';
import {
  getCUParametersComposedFromControlUnit,
  getErrorCUParametersFromControlUnit,
  getLoadingCUParametersFromControlUnit,
} from '../selectors';

export function useCUParameters(
  props: { deviceId: string; controlUnitId: string },
  handlingErrorsApi: (error: unknown) => unknown
) {
  const { deviceId, controlUnitId } = props;
  const [, loadingCuTranslate] = useCUTranslate(deviceId, controlUnitId);
  const { isLoading: isLoadingControlUnit, error: errorControlUnits } =
    useControlUnitById(deviceId, controlUnitId);

  const composedParameters = useAppSelector((state) =>
    getCUParametersComposedFromControlUnit(state, {
      deviceId,
      controlUnitId,
    })
  );

  const loading = useAppSelector((state) =>
    getLoadingCUParametersFromControlUnit(state, {
      deviceId,
      controlUnitId,
    })
  );

  const error = useAppSelector((state) =>
    getErrorCUParametersFromControlUnit(state, {
      deviceId,
      controlUnitId,
    })
  );

  // Fetch on start
  const [fetch, setFetch] = useState(true);
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (fetch) {
      dispatch(fetchCUParameters({ deviceId: deviceId, controlUnitId }))
        .unwrap()
        .catch(handlingErrorsApi);
      setFetch(false);
    }
    // FIXME: react-hooks plugin not working, eslint-disable-next-line react-hooks/exhaustive-deps
  }, [controlUnitId, deviceId, dispatch, fetch]);

  return {
    composedParameters,
    loading: loading || isLoadingControlUnit || loadingCuTranslate || fetch,
    error: error || errorControlUnits,
  };
}
